<template>
    <Card class="text-[15px]">
        <template #header>
            <div class="flex items-center justify-between w-full  p-4">
                <h3 class="text-lg font-medium text-gray-900">Meeting Information</h3>
            </div>
        </template>
        <div  v-if="!meeting.title" class="min-h-40 flex flex-col items-center justify-center">
            <div class="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
        </div>
        <div class="space-y-4" v-else>

            <div v-if="meeting.materials_published" class="flex items-start gap-3">
                <font-awesome class="w-5 h-5 mt-0.5" :icon="['far', 'book-open']" />
                <span>
                    Materials published
                    <span class="hidden md:inline">{{ meeting.materialsPublishedDate.split(' ')[0] }}</span>
                </span>
            </div>

            <!-- Description -->
            <div class="flex items-start gap-3" v-if="meeting.location">
                <font-awesome :icon="['far', 'location-dot']" class="w-5 h-5 mt-0.5" />
                <div class="flex-1">
                    <span>{{ meeting.location }}</span>
                </div>
            </div>

            <div class="flex items-start gap-3" v-if="meeting.video_link && meeting.remote_option !== 'boardable_video_conference'">
                <font-awesome :icon="['far', 'video']" class="w-5 h-5 mt-0.5" />
                <div class="flex-1 break-all whitespace-normal">
                    <a :href="meeting.video_link">{{ meeting.video_link }}</a>
                </div>
            </div>

            <div class="flex items-start gap-3" v-if="meeting.remote_url_description && meeting.remote_option !== 'boardable_video_conference'">
                <font-awesome :icon="['far', 'key']" class="w-5 h-5 mt-0.5" />
                <div class="flex-1 break-all whitespace-normal">
                    <span>Information/Pin: {{ meeting.remote_url_description }}</span>
                </div>
            </div>
            <div v-else-if="meeting.pin_code && meeting.remote_option !== 'boardable_video_conference'" class="flex items-start gap-3">
                <font-awesome :icon="['far', 'key']" class="w-5 h-5 mt-0.5" />
                <div class="flex-1 break-all whitespace-normal">
                    <span>Pin Code: {{ meeting.pin_code }}</span>
                </div>
            </div>

            <!-- Invitees — hidden when we have no participant data at all -->
            <div class="flex items-start gap-3" v-if="hasParticipants">
                <font-awesome :icon="['far', 'user-group']" class="w-5 h-5 mt-0.5" />
                <div>
                    <p class="inline">
                        <span v-if="meeting.members_and_guest_users && meeting.members_and_guest_users.length" v-text="meeting.members_and_guest_users.length > 1 ? meeting.members_and_guest_users.length + ' invitees' :  meeting.members_and_guest_users.length + ' invitee'"></span>
                        <template v-if="(meeting.members && meeting.members.length) || (meeting.guest_members && meeting.guest_members.length)">
                            (
                            <span v-if="meeting.members && meeting.members.length" v-text="meeting.members.length > 1 ? meeting.members.length + ' members' :  meeting.members.length + ' member'"></span>
                            <span v-if="meeting.guest_members && meeting.guest_members.length" v-text="meeting.guest_members.length > 1 ? ', ' + meeting.guest_members.length + ' guests' :  ', ' + meeting.guest_members.length + ' guest'"></span>
                            )
                        </template>
                    </p>
                    <Accordion title="See all" :defaultOpen="false" class="mt-1">
                        <div v-if="meeting.members && meeting.members.length" class="mb-4">
                            <div class="-ml-4 font-medium text-gray-900">Members</div>
                            <ul class="list-disc text-gray-700">
                                <li v-for="(member, i) in meeting.members">{{ member.name }}</li>
                            </ul>
                        </div>
                        <div v-if="meeting.guest_members && meeting.guest_members.length">
                            <div class="-ml-4 font-medium text-gray-900">Guests</div>
                            <ul class="list-disc text-gray-700">
                                <li v-for="(guest, i) in meeting.guest_members">{{ guest.name }}</li>
                            </ul>
                        </div>
                    </Accordion>
                </div>
            </div>
        </div>
    </Card>
</template>

<script setup>
import { computed } from 'vue';
import Card from "~/components/ui/Card.vue";
import Accordion from "~/components/ui/Accordion.vue";

const props = defineProps({
    meeting: {
        type: Object,
        required: true
    }
});

const { hasHtmlContent } = useHtmlUtils();
const hasDescription = computed(() => {
    return hasHtmlContent(props.meeting.description);
});

const hasParticipants = computed(() => {
    const m = props.meeting;
    return !!((m.members_and_guest_users && m.members_and_guest_users.length)
        || (m.members && m.members.length)
        || (m.guest_members && m.guest_members.length));
});
</script>